/**
 * Control JwPlayer video player to show video ad
 */
var VideoPlayer = /** @class */ (function () {
    /**
     * @constructor
     * @param {JWPlayerStatic} jwplayer
     * @param player
     * @param {HTMLElement} div
     * @param {string} src
     */
    function VideoPlayer(jwplayer, player, div, src, debugMode) {
        if (debugMode === void 0) { debugMode = false; }
        this.lastSrc = "";
        this.debugMode = false;
        if (this.debugMode)
            console.debug("create new instance of video player.");
        this.jwplayer = jwplayer;
        this.div = div;
        this.player = player;
        this.src = src;
        this.debugMode = debugMode;
    }
    /**
     * @func play
     * @desc change source of the video element and play ad
     */
    VideoPlayer.prototype.play = function () {
        var _this = this;
        if (this.debugMode)
            console.debug("play ad video player.");
        this.player.setControls(false);
        var video = this.getVideoElement();
        this.lastSrc = video.currentSrc;
        this.player.stop();
        setTimeout(function () {
            video.setAttribute("src", _this.src);
            video.pause();
            if (_this.debugMode)
                console.log(video.getAttribute("src"), { video: video });
            video.play();
        }, 1);
    };
    /**
     * @func skip
     * @desc skip ad
     * @param {boolean} replay
     */
    VideoPlayer.prototype.skip = function (replay) {
        if (this.debugMode)
            console.debug("skip ad video player.", this.lastSrc);
        var video = this.getVideoElement();
        video.setAttribute("src", this.lastSrc);
        this.player.setControls(true);
        if (replay) {
            video.pause();
            setTimeout(function () {
                video.currentTime = 0.1;
                video.play();
            }, 10);
        }
    };
    /**
     * @func getVideoElement
     * @desc get video element
     */
    VideoPlayer.prototype.getVideoElement = function () {
        var videoContainer = this.player.getContainer();
        return videoContainer.getElementsByTagName("video")[0];
    };
    return VideoPlayer;
}());
export default VideoPlayer;
//# sourceMappingURL=videoPlayer.js.map